"use client";

import dynamic from "next/dynamic";
import { AuthContextProvider, useSession } from "@/lib/auth/client";

// Lazy load IdleTimeoutProvider - only needed when authenticated
const LazyIdleTimeout = dynamic(() => import("./IdleTimeoutProvider"), {
  ssr: false,
});

interface AuthProviderProps {
  children: React.ReactNode;
}

// Internal wrapper that conditionally renders IdleTimeout based on auth state
function IdleTimeoutWrapper({
  children,
  timeout
}: {
  children: React.ReactNode;
  timeout: number
}) {
  const { status } = useSession();

  // Don't load idle timeout until authenticated - saves bundle weight for login page
  if (status !== "authenticated") {
    return <>{children}</>;
  }

  return <LazyIdleTimeout timeout={timeout}>{children}</LazyIdleTimeout>;
}

export default function AuthProvider({ children }: AuthProviderProps) {
  return (
    <AuthContextProvider>
      <IdleTimeoutWrapper timeout={5 * 60 * 1000}>
        {children}
      </IdleTimeoutWrapper>
    </AuthContextProvider>
  );
}
